require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconHelp.tsx
var IconHelp_exports = {};
__export(IconHelp_exports, {
  default: () => IconHelp_default
});
module.exports = __toCommonJS(IconHelp_exports);

// src/assets/monochrome/help.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgHelp = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M10 12.9659C9.59091 12.9659 9.18182 12.6591 9.18182 12.1477V11.9432C9.18182 10.8182 9.79545 9.89773 10.7159 9.48863C11.4318 9.18182 11.8409 8.36364 11.7386 7.54546C11.6364 6.82955 11.0227 6.21591 10.3068 6.11363C9.79546 6.01136 9.2841 6.11364 8.87501 6.52273C8.46592 6.82955 8.26137 7.3409 8.26137 7.85226C8.26137 8.26136 7.95455 8.67045 7.44318 8.67045C6.93182 8.67045 6.625 8.36363 6.625 7.85226C6.625 6.82954 7.0341 5.90908 7.85228 5.29545C8.56819 4.68181 9.59092 4.375 10.6136 4.57954C11.9432 4.78409 13.0682 5.90909 13.2727 7.23864C13.5795 8.77273 12.7614 10.2045 11.4318 10.8182C11.0227 11.0227 10.8182 11.4318 10.8182 11.8409V12.0455C10.7159 12.6591 10.4091 12.9659 10 12.9659Z", fill: "#676F7E" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M10 15.5227C10.3954 15.5227 10.7159 15.2022 10.7159 14.8068C10.7159 14.4114 10.3954 14.0909 10 14.0909C9.60461 14.0909 9.28409 14.4114 9.28409 14.8068C9.28409 15.2022 9.60461 15.5227 10 15.5227Z", fill: "#676F7E" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M10 19C5.09091 19 1 15.0114 1 10C1 4.98864 4.98864 1 10 1C15.0114 1 19 4.98864 19 10C19 15.0114 14.9091 19 10 19ZM10 2.63637C5.90909 2.63637 2.63637 6.01136 2.63637 10C2.63637 13.9886 6.01136 17.3636 10 17.3636C13.9886 17.3636 17.3636 13.9886 17.3636 10C17.3636 6.01136 14.0909 2.63637 10 2.63637Z", fill: "#676F7E" })
] });
var help_default = SvgHelp;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconHelp.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconHelp = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(help_default, {}) });
};
IconHelp.displayName = "IconHelp";
var IconHelp_default = IconHelp;
